import { Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import FilletTabs from "../../common-components/quality-tabs/fillet-tabs/FilletTabs";
import Overview from "@common-components/overview/Overview";
import IntakeForm from "@common-components/intake-form/IntakeForm";
import Statistics from "@common-components/statistics/Statistics";
import Monitor from "@components/Monitor/Monitor";
import QCP from "@components/QCP/QCP";
import CCP from "@components/CCP/CCP";
import Document from "@components/document/Document";
import Integration from "@components/Integration/Integration";
import QualityGraph from "@common-components/statistics/QualityGraph";
import ReceivedGraph from "@common-components/statistics/ReceivedGraph";
import BarwidthGraph from "@common-components/statistics/BarwidthGraph";
import DevExtremeForm from "@common-components/intake-form/DevExtremeForm";
import QCPTable from "@components/QCP/QCPTable";
import QCPForm from "@components/QCP/QCPForm";
import CCPForm from "@components/CCP/CCPForm";
import CCPTable from "@components/CCP/CCPTable";
import EditBatchIntake from "@common-components/intake-form/EditBatchIntake";
import EditQCP from "@components/QCP/EditQCP";
import CCPEdit from "@components/CCP/CCPEdit";
import BlobUploadForm from "@components/FileUpload";
import VolumeGraph from "@common-components/statistics/VolumeGraph";
import WeightGraph from "@common-components/statistics/SizeGraph";
import { useSelector } from "react-redux";
import ImageUploader from "@components/UploadImageToBlob";

const Fillet = () => {
  const location = useLocation();
  const userRole = useSelector((state) => state.auth.role);
  
  return (
    <>
      <div className="dx-card responsive-paddings">
        <FilletTabs /> {/* Render Sub-Tab Navigation */}
        <div style={{ marginTop: 20 }}></div>
        {userRole === "Admin" && (
          <Routes>
            <Route path="overview" element={<Outlet />}>
              <Route index element={<Overview />} />{" "}
              <Route path="edit/:id" element={<EditBatchIntake />} />{" "}
            </Route>
            <Route path="upload-image" element={<ImageUploader />} />

            <Route path="add-intake" element={<DevExtremeForm />} />
            <Route path="intake" element={<EditBatchIntake />} />
            <Route path="blobform" element={<BlobUploadForm />} />
            <Route path="statistics" element={<Statistics />} />
            <Route path="quality/:id" element={<QualityGraph />} />
            <Route path="received/:id" element={<ReceivedGraph />} />
            <Route path="colour/:id" element={<BarwidthGraph />} />

            <Route path="size/:id" element={<VolumeGraph />} />
            <Route path="volume/:id" element={<WeightGraph />} />

            <Route path="monitor" element={<Monitor />} />
            <Route path="qcp" element={<Outlet />}>
              <Route index element={<QCPTable />} />{" "}
              {/* Matches /quality/fillet/qcp */}
              <Route path="view/:id" element={<QCP />} />{" "}
              {/* Matches /quality/fillet/qcp/view/:id */}
              <Route path="add" element={<QCPForm />} />{" "}
              <Route path="edit/:id" element={<EditQCP />} />{" "}
              {/* Matches /quality/fillet/qcp/add */}
            </Route>
            <Route path="ccp" element={<Outlet />}>
              <Route index element={<CCPTable />} />{" "}
              <Route path="view/:id" element={<CCP />} />{" "}
              <Route path="edit/:id" element={<CCPEdit />} />{" "}
              <Route path="add" element={<CCPForm />} />{" "}
              {/* Matches /quality/fillet/qcp */}
            </Route>
            <Route path="integration" element={<Integration />} />

            {/* Catch-all route: Redirect only if not on overview */}
            <Route
              path="*"
              element={
                location.pathname !== "/quality/fillet/overview" ? (
                  <Navigate to="/quality/fillet/overview" replace />
                ) : null
              }
            />
          </Routes>
        )}
        {userRole === "QCPInspector" && (
          <Routes>
            <Route path="qcp" element={<Outlet />}>
              <Route index element={<QCPTable />} />
              <Route path="view/:id" element={<QCP />} />
              <Route path="add" element={<QCPForm />} />
              <Route path="edit/:id" element={<EditQCP />} />
            </Route>
            <Route path="*" element={<Navigate to="/quality/fillet/qcp" />} />
          </Routes>
        )}
        {userRole === "CCPInspector" && (
          <Routes>
            <Route path="ccp" element={<Outlet />}>
              <Route index element={<CCPTable />} />{" "}
              <Route path="view/:id" element={<CCP />} />{" "}
              <Route path="edit/:id" element={<CCPEdit />} />{" "}
              <Route path="add" element={<CCPForm />} />{" "}
              {/* Matches /quality/fillet/qcp */}
            </Route>
            <Route path="*" element={<Navigate to="/quality/fillet/ccp" />} />
          </Routes>
        )}
      </div>
    </>
  );
};

export default Fillet;
